export const queryKeys = {
    EYEABLE_RULES: 'EyeAbleRules',
    EYEABLE_RULES_META: 'EyeAbleRulesMeta',
    WCAG_RULES: 'WCAGRules',
    WCAG_RULES_META: 'WCAGRulesMeta',
    PDF_ERROR_TEXT: 'pdfErrorText',
    FOUND_URLS: 'foundUrls',
    PDFS: 'pdfs',
    USER_PDFS: 'userPdfs',
    REPORT: 'report',
    HISTORY: 'history',
    PAGE_DETAIL_REPORT: 'pageDetailReport',
    SIGNUP: 'signup',
    FOUND_URLS_HISTORY: 'foundUrlsHistory',
    NOTIFICATIONS: 'notifications',
    LIGHTHOUSE: 'lighthouse',
    URL_MAP: 'urlMap',
    ACCESS: 'access',
    LIGHTHOUSE_SUMMARY: 'lighthouseSummary',
    SPELL_CHECKING: 'spellChecking',
    SPELL_CHECKING_READABILITY_SCORE: 'spellCheckingReadabilityScore',
    SPELL_CHECKING_HISTORY: 'spellCheckingHistory',
    UPDATE_USER: 'updateUser',
    GENERATOR_FILES: 'generatorFiles',
    ADMIN_SEARCH: 'adminSearch',
    HELP_SEARCH: 'helpSearch',
    FONTS: 'fonts',
    ORG_FILES_CONTENTS: 'orgFilesContents',
    REPORT_SETTINGS: 'reportSettings',
    GUIDED_TESTING_FILES: 'guidedTestingFiles',
    GUIDED_TESTING_TESTS_OVERVIEW: 'guidedTestingTestsOverview',
    RULE_MARKDOWN: 'ruleMarkdown',
    ACC_STATES_TEXT: 'accStatesText',
    ACC_OTHER_TEXT: 'accOtherText',
};

export const demoEntry = {
    id: 451,
    domain: 'audit.zugang4all.de',
    cdnDirectory: 'audit.zugang4all.de',
    conformanceTarget: 'AAA + Best Practice',
    complianceTarget: 'AAA + Best Practice',
};

export const demoUser = {
    id: 1083,
    apiKey: '4bYhW6401da3bnP5',
    aiCreditLimit: 100000,
    aiCreditUsage: 0,
    role: 'customer',
    surname: 'DEMO',
    name: 'MODE',
    company: 'Demo Mode Company',
    email: 'info@eye-able.com',
    phone: '+49 176 64103397',
    primaryOrganisation: 1327,
    isInfinite: true,
    fullName: 'DEMO MODE',
    firstName: 'DEMO',
    lastName: 'MODE',
    hasPassword: true,
    tokenExpires: 4099852799, // 2099 in unix timestamp
};

export const demoModeConfig = {
    creationDate: '2023-04-21T11:08:44.853Z',
    enableQueryParameters: true,
    targetLang: '',
    urlsToCheck: [],
    regex: ['.*blockedUrls'],
    actions: [
        {
            regexToMatch: ['.*login'],
            timing: 'afterAudit',
            steps: [
                {
                    type: 'input',
                    target: '#username',
                    text: 'test@eye-able.com',
                },
                {
                    type: 'input',
                    text: 'mySecretPassword',
                    target: '#password',
                },
                {
                    type: 'click',
                    target: "button[type='submit']",
                },
                {
                    type: 'delay',
                    delay: '3000',
                },
            ],
        },
    ],
    dictionary: {
        1: ['Eye-Able'],
    },
};

// base endpoints
export const storageUrl = 'https://assets.eye-able.com/';
export const reportStorageUrl = 'https://report-storage.eye-able.com/';

if (import.meta.env.VITE_USE_DEV_API) console.log('Using dev API');

// for production the CDN will redirect to the correct API server
// use origin to make it work with the dev and live servers
export const apiUrl = import.meta.env.PROD
    ? window.location.origin + '/api/'
    : import.meta.env.VITE_USE_LOCAL_API === 'true'
      ? 'http://localhost:3000/'
      : import.meta.env.VITE_USE_DEV_API === 'true'
        ? 'https://apiv3-dev.eye-able.com/'
        : 'https://apiv3.eye-able.com/';

// 'http://127.0.0.1:3000/'

export const userPdfStorageUrl =
    import.meta.env.VITE_USE_LOCAL_API_PDF === 'true'
        ? 'http://127.0.0.1:3000/'
        : import.meta.env.VITE_USE_DEV_API_PDF === 'true'
          ? 'https://pdfauditapihqxkcsio-pdf-audit-api-dev.functions.fnc.fr-par.scw.cloud/'
          : 'https://pdfcheck.eye-able.com/';

// cdn translateScript adress
export const cdnTranslateScript = 'https://translate-cdn.eye-able.com/eye-able-translate.js';
//dev
//export const cdnTranslateScript = 'https://eye-able-translate-dev.b-cdn.net/eye-able-translate.js';

// api endpoints
export const api = {};

api.organisations = apiUrl + 'organisations';
api.orgFiles = api.organisations + '/settings';
api.orgFiles = api.organisations + '/files';
api.orgUsers = api.organisations + '/users';
api.orgLicenses = api.organisations + '/licenses';
api.orgIps = api.organisations + '/ipAddress';
api.usersettings = api.organisations + '/usersettings';
api.orgSettings = api.organisations + '/settings';
api.logs = apiUrl + 'loggs';
api.securityLogs = api.logs + '/security';
api.reportEntries = apiUrl + 'reportEntries';
api.reportEntriesSettings = api.reportEntries + '/settings';
api.reportEntryConfig = api.reportEntries + '/config';
api.reportEntryRescan = api.reportEntries + '/rescan';
api.listAllLicenses = apiUrl + 'listAllLicenses';
api.users = apiUrl + 'users';
api.multipleUsers = api.users + '/multiple';
api.licenseConstraints = apiUrl + 'licenseConstraints';
api.login = apiUrl + 'authentication/login';
api.samlLogin = apiUrl + 'authentication/samlLogin';
api.loginAsCustomer = apiUrl + 'authentication/loginAsCustomer';
api.signup = apiUrl + 'authentication/signup';
api.changePwd = apiUrl + 'authentication/changePw';
api.whoami = apiUrl + 'authentication/whoami';
api.pwLost = apiUrl + 'authentication/pwLost';
api.logout = apiUrl + 'authentication/logout';
api.conformanceTarget = apiUrl + 'conformanceTarget';
api.todo = apiUrl + 'todo';
api.todos = apiUrl + 'todos';
api.supportMail = apiUrl + 'supportMail';
api.offerRequest = apiUrl + 'offerRequest';
api.auditLicenses = apiUrl + 'auditLicenses';
api.assistLicenses = apiUrl + 'assistLicenses';
api.assistConfig = apiUrl + 'assistConfig';
api.assistTestLicense = api.assistLicenses + '/testLicense';
api.searchBase = apiUrl + 'search/';
api.searchAllLicenses = api.searchBase + 'allLicenses/';
api.jobs = apiUrl + 'jobs/';
api.jobsSimpleLangDocument = api.jobs + 'simpleLangDocument';
api.plainLanguage = apiUrl + 'simpleLanguage';
api.plainLanguageDocument = api.plainLanguage + '/document';
api.plainLanguageStream = api.plainLanguage + '/stream';
api.accessibilityStatement = apiUrl + 'accessibilityStatement';
api.access = apiUrl + 'access';
api.accessSettings = api.access + '/settings';
api.accessReset = api.access + '/reset';
api.accessScript = api.access + '/script';
api.ally = apiUrl + 'ally';
api.accessLicenses = apiUrl + 'accessLicenses';
api.translateClients = apiUrl + 'translateClients';
api.translateClientsAll = api.translateClients + '/all';
api.jiraConfig = apiUrl + 'jira/config';
api.jiraApiBase = apiUrl + 'jira/api';
api.jiraProjects = api.jiraApiBase + '/projects';
api.jiraProject = api.jiraApiBase + '/project';
api.jiraIssue = api.jiraApiBase + '/issue';
api.jiraIssues = api.jiraApiBase + '/issues';
api.jiraUsers = api.jiraApiBase + '/users';
api.jiraUsersFind = api.jiraUsers + '/find';
api.jiraUsersProjectAssignable = api.jiraUsers + '/project';
api.jiraIssueMetaData = api.jiraIssue + '/metadata';
api.jiraIssueComment = api.jiraIssue + '/comment';
api.jiraIssueTransition = api.jiraIssue + '/transition';
api.jiraIssueTypes = api.jiraProject + '/issuetypes';
api.jiraComponents = api.jiraProject + '/components';
api.translationsDomain = apiUrl + 'manageTranslation/domain';
api.translationsSubpage = apiUrl + 'manageTranslation/subpage';
api.translationsTranslation = apiUrl + 'manageTranslation/translation';
api.translationsManual = api.translationsTranslation + '/allManual';
api.translationSearch = api.translationsTranslation + '/search';
api.translationSingleReference = api.translationsTranslation + '/singleReference';
api.transDomainSearch = api.translationsDomain + '/search';
api.transDomainStats = api.translationsDomain + '/stats';
api.transDomainLangPairs = api.translationsDomain + '/langPairs';
api.transDomainAllTranslation = api.translationsTranslation + '/allTranslation';
api.transSubpageListAll = api.translationsSubpage + '/allSubpages';
api.transSubpageAllTranslation = api.translationsSubpage + '/allTranslation';
api.transSubpageSearch = api.translationsSubpage + '/search';
api.transSubpageStats = api.translationsSubpage + '/stats';
api.createPdf = apiUrl + 'createPdf';
api.manualTest = apiUrl + 'manualTest';
api.reportEntryFiles = api.reportEntries + '/files';
api.transcription = apiUrl + 'transcription';
api.translate_plain_apiUrl = apiUrl;
api.guidedTest = apiUrl + 'guidedTest';
api.guidedTestAll = api.guidedTest + '/all';
api.helpCenter = apiUrl + 'helpCenter';
api.helpCenterSearch = api.helpCenter + '/search';
api.listAllPartnerFiles = apiUrl + 'listPartnerFiles';
api.supportThreads = apiUrl + 'supportThreads';
api.supportThreadsAdmin = api.supportThreads + '/admin';
api.supportThreadMessages = api.supportThreads + '/messages';
api.supportThreadStatus = api.supportThreads + '/status';
api.reportExportJob = apiUrl + 'reportExportJob';
api.reportSubscription = apiUrl + 'reportSubscription';
api.ignore = apiUrl + 'ignore';
api.ignoreIssues = api.ignore + '/issue';
api.partnerContingents = apiUrl + 'partnerContingents';
api.partnerContingentsAll = api.partnerContingents + '/all';
api.partnerManagement = apiUrl + 'partnerManagement';
api.partnerManagementOrganisations = api.partnerManagement + '/organisations';
api.partnerManagementUsers = api.partnerManagement + '/users';
api.partnerManagementLicense = api.partnerManagement + '/license';
